import { GreetingHeader } from '@/components/home/GreetingHeader';
import { AnnouncementsList } from '@/components/home/AnnouncementsList';
import { QuickAccessGrid } from '@/components/home/QuickAccessGrid';

export default function Home() {
  return (
    <div className="container max-w-4xl mx-auto px-4 py-6">
      <GreetingHeader />
      <AnnouncementsList limit={5} />
      <QuickAccessGrid />
    </div>
  );
}
